import { Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { BsX } from 'react-icons/bs';
import { FacilityCell } from './FacilityCell';

export const FacilityCellDetailsPortal = () => {
  return <div id="portal-for-dropdown">{''}</div>;
};

export const FacilitiesDetails = ({
  relations,
  showStatus,
}: {
  showStatus: boolean;
  relations: {
    id: string;
    facility: {
      id: string;
      name: string;
    };
    connection_relationships: {
      facility_status: string;
    };
  }[];
}) => {
  const portal = document.getElementById('portal-for-dropdown');

  return portal ? (
    <Dropdown onClick={(e) => e.stopPropagation()} drop="up-centered">
      <Dropdown.Toggle variant="link" className="p-0 fs-14 text-dark facility-cell-dropdown-toggle">
        Show More
      </Dropdown.Toggle>
      {createPortal(
        <Dropdown.Menu className="facility-cell-dropdown-menu p-0">
          <Dropdown.Item className="facility-cell-dropdown-menu-title position-relative">
            Facilities{' '}
            <BsX size={26} viewBox={'0 0 15 15'} className="facility-cell-dropdown-menu-close" />
          </Dropdown.Item>
          {relations.slice(1).map((relation, i) => (
            <div key={i}>
              <Dropdown.Divider key={'separator-' + relation.id} className="m-0" />
              <Dropdown.Item key={relation.id}>
                <FacilityCell
                  facility={relation.facility}
                  status={relation.connection_relationships.facility_status}
                  showStatus={showStatus}
                />
              </Dropdown.Item>
            </div>
          ))}
        </Dropdown.Menu>,
        portal as HTMLElement
      )}
    </Dropdown>
  ) : null;
};
